type WithMongoId = { id?: string; _id?: string };

/** Normalize API entities that may expose `id` or `_id`. */
export function getEntityId(entity: WithMongoId | null | undefined): string {
  if (!entity) return '';
  const raw = entity.id ?? entity._id;
  return raw != null ? String(raw) : '';
}

export function normalizeEntity<T extends WithMongoId>(item: T): T & { id: string } {
  const id = getEntityId(item);
  return { ...item, id };
}

export function normalizeEntityList<T extends WithMongoId>(items: T[]): Array<T & { id: string }> {
  return (items || []).map((item) => normalizeEntity(item));
}
